import { Directive, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { AbstractControl, AsyncValidator, NG_ASYNC_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { PartnerVatCheckModel } from 'projects/workspace/src/app/partners/corporate/models/vat-check.model';
import { PartnersApiService } from 'projects/workspace/src/app/partners/corporate/services/partner-api.service';
import { Observable, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, switchMap, tap } from 'rxjs/operators';
import { VatStatusEnum } from '../../../models';

@Directive({
  selector: `
    [rnplVatValidator][formControlName][vatValidatorCountry],
    [rnplVatValidator][formControl][vatValidatorCountry],
    [rnplVatValidator][ngModel][vatValidatorCountry]
  `,
  providers: [{ provide: NG_ASYNC_VALIDATORS, useExisting: RnplVatValidatorDirective, multi: true }]
})
export class RnplVatValidatorDirective implements AsyncValidator, OnChanges {

  @Input('vatValidatorCountry') codeIso3: string;
  @Input() validatable: boolean = true;

  @Output() vatValidatorResponse: EventEmitter<PartnerVatCheckModel> = new EventEmitter<PartnerVatCheckModel>();

  constructor(
    private readonly partnerApiService: PartnersApiService,
  ) {}

  private onValidatorChange: () => void;

  registerOnValidatorChange(fn: () => void): void {
    this.onValidatorChange = fn;
  }

  ngOnChanges(): void {
    if (this.onValidatorChange) {
      this.onValidatorChange();
    }
  }

  validate(control: AbstractControl): Observable<ValidationErrors | null> {
    if (!control.value || !this.codeIso3 || !this.validatable) {
      return of(null);
    }

    return of(control.value).pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(value =>
        this.validateVatNumber(value, this.codeIso3)
      )
    );
  }

  validateVatNumber(vatNumber: string, codeIso3: string) {
    return this.partnerApiService.validateVatNumber(vatNumber, null, codeIso3).pipe(
      tap(vatResponse => this.vatValidatorResponse.emit(vatResponse)),
      map(vatResponse => ( vatResponse.valid || vatResponse.vatStatus === VatStatusEnum.NA ? null : { vatValidation: true})),
      catchError(() => of({vatValidation: true})),
    );
  }
}
